import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { CustomerContext } from '@tmh-website/shared';
import { Color } from '@tmh-website/shared/colors';
import { LocalePrefix } from '@tmh-website/shared/const';
import Button from '@tmh-website/ui/Button';
import { DropdownThemeColor } from '@tmh-website/ui/Dropdown';
import DropdownMenuItem from '@tmh-website/ui/DropdownMenuItem';

import * as Styled from './AccountDropdown.styles';

export interface AccountDropdownProps {
  dropdownThemeColor: DropdownThemeColor;
  locale: LocalePrefix;
}

const AccountDropdown = ({ dropdownThemeColor, locale }: AccountDropdownProps) => {
  const { customer } = useContext(CustomerContext);
  const { t } = useTranslation();

  return (
    <Styled.Container>
      {!customer && (
        <Styled.LoggedOutContainer>
          <Styled.LoginButtonContainer>
            <Button
              themeColor={Color.Blue_500_Ultramarine}
              hoverThemeColor={Color.Blue_1000_Deep}
              isSmall
              href={`/${locale}/customer/account/login`}>
              {locale === LocalePrefix.De ? 'Privat' : 'Anmelden'}
            </Button>
            {locale === LocalePrefix.De && (
              <Button
                themeColor={Color.Blue_500_Ultramarine}
                hoverThemeColor={Color.Blue_1000_Deep}
                isSmall
                href='https://partner.mobilityhouse.com/de_de/'>
                Partner
              </Button>
            )}
          </Styled.LoginButtonContainer>
          <Trans t={t} i18nKey='global:account.registerPrompt'>
            Neuer Kunde? <a href={`/${locale}/customer/account/create`}>Jetzt registrieren</a>
          </Trans>
        </Styled.LoggedOutContainer>
      )}

      <DropdownMenuItem themeColor={dropdownThemeColor} href={`/${locale}/customer/account`}>
        {t('global:account.myAccount')}
      </DropdownMenuItem>
      <DropdownMenuItem themeColor={dropdownThemeColor} href={`/${locale}/sales/order/history`}>
        {t('global:account.myOrders')}
      </DropdownMenuItem>
      <DropdownMenuItem themeColor={dropdownThemeColor} href={`/${locale}/wishlist`}>
        {t('global:account.myBookmarks')}
      </DropdownMenuItem>
      <DropdownMenuItem themeColor={dropdownThemeColor} href={`/${locale}/catalog/product_compare`}>
        {t('global:account.myCompareList')}
      </DropdownMenuItem>

      {customer && (
        <>
          <Styled.Line />
          <DropdownMenuItem themeColor={dropdownThemeColor} href={`/${locale}/customer/account/logout`}>
            {t('global:account.logout')}
          </DropdownMenuItem>
        </>
      )}
    </Styled.Container>
  );
};

export default AccountDropdown;
